import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class UserAccessService {
    constructor(private http: HttpClient) { }
    
    public isExternalAccess(): Observable<boolean> {
        return this.http.get<boolean>("/api/User/UserAccess");
    }
}